import React, { PropTypes } from 'react'
import CSSModules from 'react-css-modules'

import EventReviewListItem from 'components/event-review-list-item'
import { getSetupformUrl } from 'utils/urls'
import { STAGE_STATUS } from 'constants/setupform-constants'

import styles from './event-review-list.css'

const EventReviewList = ({ events, partnerId, subtitle, title }) => (
  <div styleName="event-review-list">
    <h2 styleName="title">{title}</h2>
    <h3 styleName="subtitle">{subtitle}</h3>

    {events.map((event, index) => (
      <EventReviewListItem
        key={index}
        name={event.name || 'Untitled'}
        url={getSetupformUrl(partnerId, event.id, STAGE_STATUS.SUMMARY)}
        venue={event.venue ? event.venue.name : ''}
      />
    ))}
  </div>
)

EventReviewList.propTypes = {
  events: PropTypes.array,
  partnerId: PropTypes.any,
  subtitle: PropTypes.string,
  title: PropTypes.string,
}

export default CSSModules(EventReviewList, styles, { allowMultiple: true })



/** WEBPACK FOOTER **
 ** ./src/components/event-review-list/event-review-list.js
 **/